import { render, staticRenderFns } from "./SampleHeader.vue?vue&type=template&id=3b506803&scoped=true"
import script from "./SampleHeader.vue?vue&type=script&lang=js"
export * from "./SampleHeader.vue?vue&type=script&lang=js"
import style0 from "./SampleHeader.vue?vue&type=style&index=0&id=3b506803&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b506803",
  null
  
)

export default component.exports